import { Group } from '@/router/group.model';
import { sellCoinsV2, revenueReports } from '../routes';

const routes = [sellCoinsV2, revenueReports];

const sellCoinsGroup = new Group(
  'Sell Coins & Gift Cards',
  'sell-coins',
  routes,
  {
    superRoot: false,
    description:
      'Enable customers to buy Coins to use as store credit, or gift to others.'
  }
);

export { sellCoinsGroup };
export default sellCoinsGroup;
